import styled, { css } from 'styled-components';

export type BadgeType =
  | 'warning'
  | 'danger'
  | 'success'
  | 'info'
  | 'purple'
  | 'primary'
  | 'secondary'
  | 'terciary'
  | 'darkGray';

interface IContainerProps {
  type: BadgeType;
  isDisabled: boolean;
  href: string;
  breakRow: boolean;
}

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const Container = styled.div<IContainerProps>`
  display: inline-block;
  padding: 11px 10px;

  background: ${({ theme, type }) => theme.colors[type]}33;

  color: ${({ theme, type }) => theme.colors[type]};
  border-radius: ${({ theme }) => theme.borderRadius.lg};

  ${({ breakRow }) =>
    breakRow
      ? css`
          line-height: normal;
          text-align: center;
        `
      : css`
          line-height: 0px;
        `}

  font-size: 9px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  cursor: default;

  transition: all 0.3s;

  ${({ onClick, type, theme, href }) =>
    (!!onClick || !!href) &&
    css`
      cursor: pointer;

      &:hover {
        background: ${theme.colors[type]}55;
      }
    `}

  ${({ theme, type, isDisabled }) =>
    isDisabled &&
    css`
      cursor: not-allowed;
      opacity: 0.65;

      &:hover {
        background: ${theme.colors[type]}33;
      }

      pointer-events: none;
    `}
`;
